import axios from "axios";

const BASE_URL = "https://assistant-api.aigents.services";

export const sendMessage = async (userId, text) => {
  const response = await axios.post(`${BASE_URL}/api/v1/chat/send_message`, {
    user_id: userId,
    text,
  });
  return response.data;
};

